import { createSelector } from 'reselect';
// import formatFacility from '../../utils/store/formatFacility';

export const getNearbyFacilities = createSelector(
	(state) => state.pages?.content?.nearbyFacilities || {},
	(nearbyFacilities) => {
		if (
			!nearbyFacilities.facilityCollection ||
			!nearbyFacilities.facilityCollection.collection
		) {
			return null;
		}
		const formatedNearbyFacilities =
			nearbyFacilities?.facilityCollection?.collection.map((facility) =>
				facility?.collection ? facility.collection : facility,
			);
		nearbyFacilities.facilityCollection.collection =
			formatedNearbyFacilities || [];

		return nearbyFacilities;
	},
);
